import R from "ramda";
import { http } from "./http";

export const fetchCardNumbers = (accountId) => (
  http.get(`/accounts/${accountId}/credit-cards`)
    .then(response => {
      const cardNumbers = R.pathOr([], ["data", "creditCards"], response);
      return { cardNumbers, response };
    })
);



// WEBPACK FOOTER //
// ./src/js/api/card-numbers.js